
import axios from 'axios';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import UTILService from '@/services/utils.service';
import {
  Vue,
  Component,
  Watch,
  Model,
  Prop,
  Ref,
} from 'vue-property-decorator';
import VideoUModal from '@/components/video/VideoModal.vue';
import { $delay } from '@/common/utils';
import { BASE_URL } from '@/common/constant';
import UserService from '@/services/user.service';
import { ISPUImageUploadOptions } from '@/common/interface/spu';

interface IVideo {
  id: string;
  url: string;
  cover: string;
  order?: number;
  origin_url?: string;
}

@Component({
  components: {
    VideoUModal,
  },
})
export default class VideosField extends Vue {
  videosLimit = 1;

  uploading = false;

  BASE_URL = BASE_URL;

  uploadProgress: any = 0;

  val: any[] = [];

  token: string | undefined = undefined;

    /** 上传配置 */
  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  watchable = true;

  @Prop({
    default: () => {
      return '';
    },
  })
  shopId!: string;

  @Prop({
    default: () => {
      return true;
    },
  })
  deleteType!: boolean;

  @Model('change')
  value!: IVideo[];

  @Ref()
  videoModal!: VideoUModal;

  @lazyInject(UserService)
  protected userService!: UserService;


  @Watch('val')
  watchInternalVal(): void {
    this.$emit(
      'change',
      !this.val.length ? [-1] : this.val.map((item) => item.id),
    );
  }

  @Watch('value')
  watchValue() {
    if (!this.watchable) {
      return;
    }
    if (this.value.length) {
      this.val = [...this.value];
    } else {
      this.val = [];
    }
  }

  @lazyInject(ShopService)
  protected shopService!: ShopService;

  @lazyInject(UTILService)
  protected toolsService!: UTILService;

  removeVideo(idx: number) {
    const videos = [...this.val];
    videos.splice(idx, 1);
    this.val = [...videos];
  }

  async getVideosLimit() {
    // const res = await this.shopService.shopVideosLimit();
    // if (res) {
    //   this.videosLimit = res;
    // }
  }

  async beforeUploadVideo(file: File) {
    const isLt150M = file.size / 1024 / 1024 < 100;
    if (!isLt150M) {
      this.$message.error('视频必须小于100MB!');
    }
  }

  openVideoModal(videoUrl: string) {
    this.videoModal.open(videoUrl);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async customUpload($event: any) {
    if (this.uploading) {
      return;
    }
    this.uploading = true;

    const ossConfig = await this.toolsService.getOssConfig('ka_id');
    if (ossConfig == null) {
      this.uploading = false;
      return;
    }

    const { access_id, policy, signature, callback, dir, host, file_name } =
      ossConfig;
    const { file } = $event;
    const extensionName: string = file.name.split('.')[1];

    const formData = new FormData();
    formData.append('key', `${dir}${file_name}.${extensionName}`);
    formData.append('name', file_name);
    formData.append('OSSAccessKeyId', access_id);
    formData.append('policy', policy);
    formData.append('signature', signature);
    formData.append('success_action_status', '200');
    formData.append('callback', callback);
    formData.append('file', file);

    try {
      axios({
        url: host,
        data: formData,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: ({ loaded, total }) => {
          const percent = (loaded / total) * 100;
          $event.onProgress({ percent });
          this.uploadProgress = percent.toFixed(2);
        },
      }).then(
        (res) => {
          if (res) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const { cover, id, url, origin_url } = res as any;
            const videos = [...this.val];
            videos.unshift({
              id,
              url,
              cover,
              origin_url: origin_url as string,
            });
            this.val = [...videos];

            $event.onSuccess(res, file);
            this.uploading = false;
          }
        },
        (err) => {
          $event.onError(err);
          this.uploading = false;
        },
      );
    } catch (error) {
      $event.onError(error);
      this.uploading = false;
    }
  }

  /** @todo 确认是否需要更改为OSS直传方式 */
  beforeUpload(file: { type: string; size: number }) {
    const isLt5M = file.size / 1024 / 1024 < 20;
    if (!isLt5M) {
      this.$message.error('视频必须小于20MB!');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onUploadChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const result = {
        id: data[0]?.id,
        url: data[0]?.url,
      };
      this.val = [result];

      this.uploading = false;
    }
  }


  async mounted() {
    this.watchValue();
    this.watchable = false;
    // await this.getVideosLimit();
  }
  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }
}
